/* ATELIER DU TEMPS — interactions */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  function money(c) {
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cur }).format(c / 100).replace(/,00(?=\s)/, ''); }
    catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  var hdr = $('#hdr'), top = $('[data-totop]');
  function onScroll() {
    var y = window.scrollY;
    if (hdr) hdr.classList.toggle('is-scrolled', y > 10);
    if (top) top.classList.toggle('is-on', y > 700);
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  $$('[data-nav-toggle]').forEach(function (b) {
    b.addEventListener('click', function () { document.body.classList.toggle('nav-open'); });
  });

  var sb = $('[data-search-toggle]'), sp = $('#srch');
  if (sb && sp) sb.addEventListener('click', function () {
    var open = sp.classList.toggle('is-open');
    sb.setAttribute('aria-expanded', open);
    if (open) { var i = $('input[type=search]', sp); i && i.focus(); }
  });

  function openDr(d) { if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; var f = $('.dr__x', d); f && f.focus({ preventScroll: true }); }
  function closeDr(d) { if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  $$('[data-open]').forEach(function (b) { b.addEventListener('click', function () { openDr(document.getElementById(b.dataset.open)); }); });
  $$('#filters [data-close]').forEach(function (b) { b.addEventListener('click', function () { closeDr($('#filters')); }); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.dr.is-open').forEach(closeDr);
    document.body.classList.remove('nav-open');
    var z = $('#zoom'); z && z.classList.remove('is-open');
  });

  var drawer = $('#cart-drawer');
  function setCount(n) { $$('.cart-count').forEach(function (c) { c.textContent = n; c.dataset.n = n; }); }
  function refreshCart() {
    return fetch(root + '?sections=atd-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j['atd-cart-drawer'], 'text/html');
        var np = $('.dr__panel', doc), op = drawer && $('.dr__panel', drawer);
        if (np && op) { op.innerHTML = np.innerHTML; setCount(np.dataset.count || 0); }
      });
  }
  window.ATD = { refreshCart: refreshCart, openCart: function () { openDr(drawer); } };
  $$('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) { if (drawer) { e.preventDefault(); openDr(drawer); } });
  });
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { closeDr(drawer); return; }
      var b = e.target.closest('[data-line]');
      if (!b) return;
      drawer.classList.add('is-busy');
      fetch(root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, +b.dataset.q) })
      }).then(refreshCart).finally(function () { drawer.classList.remove('is-busy'); });
    });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-atd-add]');
    if (!f || !drawer) return;
    e.preventDefault();
    var btn = $('[type=submit]', f), label = btn ? btn.innerHTML : '', err = $('.form-err', f);
    if (btn) { btn.disabled = true; btn.innerHTML = 'Ajout…'; }
    if (err) err.textContent = '';
    fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Impossible d\'ajouter ce produit.'); return j; }); })
      .then(refreshCart)
      .then(function () { openDr(drawer); })
      .catch(function (x) { if (err) err.textContent = x.message; else window.location.href = root + 'cart'; })
      .finally(function () { if (btn) { btn.innerHTML = label; btn.disabled = btn.dataset.na === '1'; } });
  });

  $$('[data-slide]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = document.getElementById(b.dataset.slide);
      if (t) t.scrollBy({ left: (+b.dataset.dir) * Math.max(280, t.clientWidth * 0.75), behavior: 'smooth' });
    });
  });

  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  var pj = $('#pdp-json'), form = $('#pdp-form');
  if (pj && form) {
    var variants = JSON.parse(pj.textContent);
    var main = $('#pdp-main');
    var slides = $$('.pdp__slide', main), thumbs = $$('[data-thumb]');
    var idx = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-on'); }));
    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === idx); });
      var id = slides[idx].dataset.media;
      thumbs.forEach(function (t) { t.classList.toggle('is-on', t.dataset.thumb === id); });
    }
    function showMedia(id) { var k = slides.findIndex(function (s) { return s.dataset.media == id; }); if (k > -1) show(k); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.thumb); }); });
    $$('[data-gal]').forEach(function (b) { b.addEventListener('click', function () { show(idx + (+b.dataset.gal)); }); });
    var sx = null;
    main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1)); sx = null; });

    var zoom = $('#zoom');
    main.addEventListener('click', function (e) {
      var img = e.target.closest('.pdp__slide img'); if (!img || !zoom) return;
      $('img', zoom).src = img.dataset.zoom || img.currentSrc || img.src; zoom.classList.add('is-open');
    });
    if (zoom) zoom.addEventListener('click', function () { zoom.classList.remove('is-open'); });

    var addBtn = $('#pdp-add'), idInput = $('#pdp-id'), priceBox = $('#pdp-price'), satcPrice = $('#satc-price');
    function selected() { return $$('.opt', form).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function match(sel) { return variants.find(function (v) { return v.options.every(function (o, k) { return o === sel[k]; }); }); }
    function markAvailability(sel) {
      $$('.opt', form).forEach(function (fs, i) {
        $$('input', fs).forEach(function (inp) {
          var t = sel.slice(); t[i] = inp.value; var m = match(t);
          inp.closest('.chip').classList.toggle('is-na', !m || !m.available);
        });
      });
    }
    function update(push) {
      var sel = selected(); markAvailability(sel);
      $$('[data-opt-label]').forEach(function (l) { l.textContent = sel[+l.dataset.optLabel] || ''; });
      var v = match(sel);
      if (!v) { addBtn.disabled = true; addBtn.dataset.na = '1'; addBtn.textContent = 'Indisponible'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available; addBtn.dataset.na = v.available ? '0' : '1';
      addBtn.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      var h = '<span>' + money(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) h += '<s>' + money(v.compare_at_price) + '</s><span class="save">−' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + ' %</span>';
      priceBox.innerHTML = h; if (satcPrice) satcPrice.textContent = money(v.price);
      if (v.featured_media) showMedia(v.featured_media.id);
      if (push) history.replaceState(null, '', window.location.pathname + '?variant=' + v.id);
    }
    form.addEventListener('change', function (e) { if (e.target.matches('[data-opt]')) update(true); });
    if ($$('.opt', form).length) markAvailability(selected());

    var q = $('#pdp-qty');
    $$('[data-step]', form).forEach(function (b) { b.addEventListener('click', function () { q.value = Math.max(1, (+q.value || 1) + (+b.dataset.step)); }); });

    var satc = $('#satc');
    if (satc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0]; var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        satc.classList.toggle('is-on', past); satc.setAttribute('aria-hidden', !past);
      }).observe(addBtn);
      $('[data-satc]', satc).addEventListener('click', function () {
        if (addBtn.disabled) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }

    function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    var fmt = function (d) { return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }); };
    $$('[data-deliv]').forEach(function (el) {
      var r = el.dataset.deliv.split('-'); if (r[0] === '0') return;
      var now = new Date();
      el.textContent = fmt(addBiz(now, +r[0])) + ' – ' + fmt(addBiz(now, +r[1]));
    });
  }

  var rv = $$('.rv, [data-banner]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    rv.forEach(function (el) { io.observe(el); });
  } else { rv.forEach(function (el) { el.classList.add('in'); }); }
})();
